import {
  Button,
  ReferenceInput,
  SelectInput,
  TextInput,
  useDataProvider,
  useNotify,
  useRefresh,
  AutocompleteInput,
  required,
} from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import Edit from "@mui/icons-material/Edit";
import { Grid, useMediaQuery } from "@mui/material";

import { administrationRequests } from "api/administrationApi";
import { useFormContext } from "react-hook-form";
import { useEffect, useState } from "react";
import { settings } from "app";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { PreviousEducationType } from "utils/choices";
import { studentRequests } from "api/studentApi";

const EditPreviousEducationInfoModal = ({ record, data }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const [isConfirmEnabled, setIsConfirmEnabled] = useState(false);

  const handleSubmit = async formData => {
    const payload = {
      diplomaRegistration: formData.diplomaRegistration,
      diplomaSerialNumber: formData.diplomaSerialNumber,
      diplomaDate: formData.diplomaDate ? formData.diplomaDate?.split("T")[0] : null,
      diplomaSeries: formData.diplomaSeries,
      graduationYear: formData.graduationYear,
      institution: formData.institution,
      educationType: formData.educationType,
      profession: formData.profession,
      degreeId: formData.degreeId,
      countryId: formData.countryId,
      settlementId: formData.settlementId,
    };
    try {
      await dataProvider.customRequest(
        studentRequests.updateStudentPreviousEducation({ studentId: record.studentId, studentEducationId: data.id }),
        payload,
        "PUT",
      );
      refresh();
      notify("Успешна Редакция на данни от предходно образование", { type: "success" });
    } catch (e) {
      notify("Неуспешна заявка", { type: "error" });
    }
  };

  return (
    <FormModal
      titleContent="Редакция на данни от предходно образование"
      onConfirm={handleSubmit}
      confirmEnabled={isConfirmEnabled}
      defaultValues={data || {}}
      triggerButton={
        <Button
          label="Редакция на образование"
          variant="contained"
          startIcon={<Edit />}
        />
      }
    >
      <FormContent
        setIsConfirmEnabled={setIsConfirmEnabled}
        data={data}
        isMobile={isMobile}
      />
    </FormModal>
  );
};

const FormContent = ({ setIsConfirmEnabled, data, isMobile }) => {
  const {
    formState: { isDirty: formDirty },
  } = useFormContext();

  useEffect(() => {
    setIsConfirmEnabled(formDirty);
  }, [formDirty, setIsConfirmEnabled]);

  return (
    <Grid
      spacing={2}
      container
      sx={{ ...settings.style.shadowBoxMobile, paddingRight: "2rem", width: "99%" }}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          label="Серия на диплома"
          source="diplomaSeries"
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          label="Рег. Номер на диплома"
          source="diplomaRegistration"
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          label="Сериен номер на диплома"
          source="diplomaSerialNumber"
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <CustomDateInput
          label="Дата на диплома"
          locales="bg-BG"
          source="diplomaDate"
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          label="Година на завършване"
          source="graduationYear"
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          label="Учебно заведение"
          source="institution"
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
      >
        <SelectInput
          label="Тип образование"
          source="educationType"
          choices={PreviousEducationType}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          label="Профил"
          source="profession"
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceInput
          source="degreeId"
          textAlign="center"
          reference={administrationRequests.getDegreesSelect()}
        >
          <SelectInput
            source="name"
            label="Квалификационна степен"
          />
        </ReferenceInput>
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceInput
          source="countryId"
          reference={administrationRequests.getCountriesSelect()}
        >
          <AutocompleteInput
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
            optionText="nameBg"
            label="Държава"
            validate={required()}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceInput
          source="settlementId"
          reference={administrationRequests.getSettlementsSelect()}
        >
          <AutocompleteInput
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
            optionText="nameBg"
            optionValue="id"
            label="Град"
            validate={required()}
          />
        </ReferenceInput>
      </Grid>
    </Grid>
  );
};

export default EditPreviousEducationInfoModal;
